// 会话 store — 当前活跃的 WebRTC 文件传输会话

import { create } from 'zustand';
import type { FileDto, TransferStatus } from '@kuaichuan/shared';

export interface TransferFile extends FileDto {
  receivedBytes: number;
  status: 'pending' | 'sending' | 'done' | 'error';
  error?: string;
}

interface SessionState {
  // 当前会话对方 peer
  remotePeerId: string | null;
  remotePeerAlias: string | null;
  // 文件列表（含进度）
  files: TransferFile[];
  // 整体状态
  status: TransferStatus;
  // 角色
  role: 'sender' | 'receiver' | null;

  setRemote: (peerId: string, alias: string) => void;
  setRole: (role: 'sender' | 'receiver') => void;
  setStatus: (status: TransferStatus) => void;
  setFiles: (files: FileDto[]) => void;
  updateFileProgress: (fileId: string, receivedBytes: number) => void;
  setFileStatus: (fileId: string, status: TransferFile['status'], error?: string) => void;
  reset: () => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  remotePeerId: null,
  remotePeerAlias: null,
  files: [],
  status: 'idle',
  role: null,

  setRemote: (peerId, alias) => set({ remotePeerId: peerId, remotePeerAlias: alias }),
  setRole: (role) => set({ role }),
  setStatus: (status) => set({ status }),
  setFiles: (files) =>
    set({
      files: files.map((f) => ({ ...f, receivedBytes: 0, status: 'pending' })),
    }),
  updateFileProgress: (fileId, receivedBytes) =>
    set((s) => ({
      files: s.files.map((f) => (f.id === fileId ? { ...f, receivedBytes, status: 'sending' } : f)),
    })),
  setFileStatus: (fileId, status, error) =>
    set((s) => ({
      files: s.files.map((f) => (f.id === fileId ? { ...f, status, error } : f)),
    })),
  reset: () =>
    set({
      remotePeerId: null,
      remotePeerAlias: null,
      files: [],
      status: 'idle',
      role: null,
    }),
}));
